import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { SubscriberChannelLayoutComponent } from './layouts/subscriber-channel-layout/subscriber-channel-layout.component';
import { SubscriberChannelCardComponent } from './components/subscriber-channel-card/subscriber-channel-card.component';
import { SubscriberChannelDatatableComponent } from './components/subscriber-channel-datatable/subscriber-channel-datatable.component';
import { MediatypeStatCardsComponent } from './components/mediatype-stat-cards/mediatype-stat-cards.component';

const DECLARATIONS = [
  SubscriberChannelLayoutComponent,
  SubscriberChannelCardComponent,
  SubscriberChannelDatatableComponent,
  MediatypeStatCardsComponent
];

const MODULES = [SharedModule];

// const IMPORT_ONLY_MODULES = [NgxsModule.forFeature([])];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class SubscriberChannelModule {}
